<template>
<v-form v-model="valid" ref="form">
    <v-row class="ma-0 pa-0" v-show="readonly">
        <v-col cols="auto" class="d-flex justify-start ps-0 pt-0">
        <bee-btn context="material" :action-name="actions.EDIT"  color="editingColor" @click="readonly = false" :loading="loading" :disabled="file_is_locked" outer-class="me-3">
            <template v-slot:content="" >
                <v-img width="25" contain :src="require('../../../../assets/edit-product.png')" class="mx-1"></v-img>
                {{$t('MaterialCreateEdit.edit')}}
            </template>
        </bee-btn>
        <bee-btn context="material" :action-name="actions.DELETE" color="deletingColor" :loading="loading" @click="deleteDialog = true" :disabled="file_is_locked">
            <template v-slot:content="" >
                <v-img width="25" contain :src="require('../../../../assets/remove-product.png')" class="mx-1"></v-img>
                {{$t('MaterialCreateEdit.delete')}}
            </template>
        </bee-btn>
        </v-col>
    </v-row>
    <v-row class="ma-0 pa-0" v-show="!readonly">
        <v-col cols="auto" class="d-flex justify-start ps-0 pt-0">
        <bee-btn context="material" :action-name="actions.EDIT"  color="editingColor" @click="save()" :loading="loading" :disabled="!valid || file_is_locked" outer-class="me-3">
            <template v-slot:content="" >
                <v-img width="25" contain :src="require('../../../../assets/save-product.png')" class="mx-1"></v-img>
                {{$t('MaterialCreateEdit.save')}}
            </template>
        </bee-btn>
        <bee-btn
            context="material"
            :action-name="actions.DELETE"
            color="deletingColor"
            :content="$t('MaterialCreateEdit.cancel')"
            :loading="loading"
            @click="cancel()"
        >
        </bee-btn>
        </v-col>
    </v-row>
	<v-card>
        <v-card-text class="pt-0">
                <v-card-title class="px-0">
					{{$t('MaterialCreateEdit.basic-data')}}
				</v-card-title>
                <v-layout align-start align-content-center justify-space-between row wrap>
					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-text-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.material-name')"
						    :rules="[rules.required]"
						    v-model="material.name"
						></bee-text-field>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-material-autocomplete
						    :with-balance="true"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.main-material')"
						    color="primary"
						    @change="change()"
						    v-model="material.parent_id"
						    :items="warehouse_materials.filter(c=>c.type == 1)"
						    :clearable="true"
						></bee-material-autocomplete>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-accounting-no-field
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.account-no-is-automatic-or-manual')"
						    ref="innerNo"
						    :prefix="prefix"
						    v-model="material.inner_no"
						    :rules="[rules.required]"
						></bee-accounting-no-field>
					</v-col>
					
					<!-- barcode -->
					<v-col v-if="multipleWarehouses" cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<!-- 245800224057 -->
						<v-text-field 
							v-model="material.barcode"
							outlined
							dense
							hide-details
							type="number"
							hide-spin-buttons
							:label="$t('inputs.barcode')"
							:disabled="readonly"
						/>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-autocomplete
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    color="primary"
						    :label="$t('MaterialCreateEdit.material-type.title')"
						    item-text="name"
						    item-value="value"
						    :items="configs.material_types.filter(c=>c.value).map(c=>({...c,
								name:
								c.value == 1 ? $t('MaterialCreateEdit.material-type.main') :
								c.value == 2 ? $t('MaterialCreateEdit.material-type.sub') :
								c.name })) || []"
						    v-model="material.type"
						    :rules="[rules.required]"
						></bee-autocomplete>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-autocomplete
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.material-category.title')"
						    item-value="value"
						    itemText="name"
						    :items="configs.material_categories.filter(c=>c.value).map(c=>({...c,
							name:
								c.value == materialCategory.commodity ? $t('MaterialCreateEdit.material-category.commercial-ordinary-material') :
								c.value == materialCategory.raw ? $t('MaterialCreateEdit.material-category.raw-material') :
								c.value == materialCategory.indirectRaw ? $t('MaterialCreateEdit.material-category.indirect-raw-material') :
								c.value == materialCategory.inProcess ? $t('MaterialCreateEdit.material-category.material-under-manufacture') :
								c.value == materialCategory.finished ? $t('MaterialCreateEdit.material-category.manufactured-material') :
								c.name })) || []"
						    v-model="material.category"
						    :rules="[rules.required]"
						></bee-autocomplete>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-autocomplete
						    context="unit_size"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.unit-size')"
						    item-value="id"
						    itemText="name"
						    :items="unit_sizes"
						    v-model="material.unit_size_id"
						    :rules="[rules.required]"
						></bee-autocomplete>
					</v-col>
				</v-layout>

				<v-card-title class="pt-0 px-0">
					{{$t('MaterialCreateEdit.additional-data')}}
				</v-card-title>
                <v-layout align-start align-content-center justify-space-between row wrap>
					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-text-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.min')"
						    :rules="[rules.numeric]"
						    v-model="material.min_quantity"
						></bee-text-field>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-text-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.max')"
						    :rules="[rules.numeric]"
						    v-model="material.max_quantity"
						></bee-text-field>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-text-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.manufacturer')"
						    v-model="material.manufacturer"
						></bee-text-field>
					</v-col>

					<v-col cols="12" lg="12" md="12" sm="6" xs="12" class="py-1">
						<bee-text-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.specifications')"
						    v-model="material.specifications"
						></bee-text-field>
					</v-col>
                </v-layout>

				<v-card-title class="pt-0 px-0">
					{{$t('MaterialCreateEdit.material-movement-data')}}
				</v-card-title>
                <v-layout align-start align-content-center justify-space-between row wrap>
					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-money-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.purchasing-price')"
						    v-model="material.purchase_price"
						    :rules="[rules.money]"
						></bee-money-field>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-money-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.selling-price')"
						    v-model="material.sale_price"
						    :rules="[rules.money]"
						></bee-money-field>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-account-autocomplete
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.purchase-account')"
						    color="primary"
						    :clearable="true"
						    :with-balance="true"
						    v-model="material.purchases_account_id "
						    :items="configs.accounts.filter(c=>c.final_type == 2)"
						></bee-account-autocomplete>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-account-autocomplete
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('inputs.purchasing-refund-account')"
						    color="primary"
						    :clearable="true"
						    :with-balance="true"
						    v-model="material.purchases_refund_account_id "
						    :items="configs.accounts.filter(c =>c.final_type == 2)"
						></bee-account-autocomplete>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-account-autocomplete
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.sales-account')"
						    color="primary"
						    :clearable="true"
						    :with-balance="true"
						    v-model="material.sales_account_id "
						    :items="configs.accounts.filter(c=>c.final_type == 2)"
						></bee-account-autocomplete>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-account-autocomplete
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('inputs.sales-refund-account')"
						    color="primary"
						    :clearable="true"
						    :with-balance="true"
						    v-model="material.sales_refund_account_id "
						    :items="configs.accounts.filter(c =>c.final_type == 2)"
						></bee-account-autocomplete>
					</v-col>
					
					<v-col cols="12" lg="8" md="8" sm="6" xs="12" class="py-1">
						<bee-text-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.notes')"
						    v-model="material.notes"
						></bee-text-field>
					</v-col>
                </v-layout>

			</v-card-text>
    </v-card>
	<!-- materials linked -->
	<!-- dialog -->
	<template v-if="multipleWarehouses">
		<v-dialog
			v-model="unbindDialog"
			persistent
			max-width="400px"
			transition="dialog-top-transition"
		>
			<v-card>
				<v-card-title> {{ $t('MaterialCreateEdit.confirm-disengagement-of-material') }} </v-card-title>
				<v-card-text>
					{{$t('MaterialCreateEdit.are-you-sure-you-want-to-disconnect?')}}
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn @click="deleteLinkItem()" :loading="loading" color="deletingColor" text>
						{{ $t('buttons.ok') }}
					</v-btn>
					<v-btn text @click="unbindDialog = false">
						{{ $t('cancel') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-card 
			v-if="(Boolean($route.params.id) && (userTypePermission === userType.warehouseManger)) || 
			(Boolean($route.params.id) && isAdmin)" class="mt-2"
		>
			<!-- <v-card-title>
				{{ $t('MaterialCreateEdit.interlocking-materials') }}
			</v-card-title> -->
			<v-card-text class="pt-0">
				<!--  -->
				<h3 class="pb-2">
					{{ $t('MaterialCreateEdit.materials-that-have-the-same-barcode') + ':'}}
				</h3>
	
				<!-- materialSameBarcode -->
				<bee-handy-table
					:items="materialSameBarcode.filter(c => c.id !== material.id)"
					:headers="headerSameBar"
					zebra
					dense
					:items-per-page="-1"
					hide-default-footer
					class="mb-3"
					height="auto"
					:loading="loading"
				>
					<template v-slot:item.actions="{ item }">
						<v-btn @click="link(item.id)" icon color="success" :disabled="readonly">
							<v-icon> mdi-link-box-variant-outline </v-icon>
						</v-btn>
					</template>
				</bee-handy-table>
				<bee-handy-smart-table
					ref="table"
					v-model="tableInputs"
					:items="itemLinkedWithMaterials"
					:headers="headers"
					dense
					zebra
					:items-per-page="-1"
					:show-add-row="!loading && !readonly"
					hide-default-footer
					@keypress.enter="link()"
					:loading="loading"
				>
					<template v-slot:input.warehouse_id="{ on, attrs }">
						<v-autocomplete 
							:items="warehouses.filter(c => c.id !== $route.params.warehouseId)"
							item-text="name"
							item-value="id"
							v-on="on"
							v-bind="attrs"
						/>
					</template>
	
					<template v-slot:input.id="{ on, attrs }">
						<v-autocomplete 
							:items="materials.filter(c => c.warehouse_id === tableInputs.warehouse_id)"
							item-text="name"
							item-value="id"
							v-on="on"
							v-bind="attrs"
						/>
					</template>
					<template v-slot:item.actions="{ item }">
						<div class="d-flex justify-end">
							<v-btn icon @click="itemId = item.id; unbindDialog = true" :disabled="readonly">
								<v-icon color="danger-dark-color">mdi-delete</v-icon>
							</v-btn>
						</div>
					</template>
				</bee-handy-smart-table>
			</v-card-text>
		</v-card>
	</template>
	
					
			
		<!-- materials linked -->
		<!-- dialog -->
		<v-dialog
			v-model="unbindDialog"
			persistent
			max-width="400px"
			transition="dialog-top-transition"
		>
			<v-card>
				<v-card-title> {{ $t('MaterialCreateEdit.confirm-disengagement-of-material') }} </v-card-title>
				<v-card-text>
					{{$t('MaterialCreateEdit.are-you-sure-you-want-to-disconnect?')}}
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn @click="deleteLinkItem()" :loading="loading" color="deletingColor" text>
						{{ $t('buttons.ok') }}
					</v-btn>
					<v-btn text @click="unbindDialog = false">
						{{ $t('cancel') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>		
		
		<v-card v-if="useInvoicesTypes" class="mt-4">
			<v-card-title></v-card-title>
			<v-card-text></v-card-text>
		</v-card>
	
		<!-- material linked -->
		<v-card></v-card>
	
		<bee-dialog
			@handler="confirmDelete()"
			@close="deleteDialog = false"
			v-model="deleteDialog"
			:title="$t('MaterialCreateEdit.delete-the-material')"
			:message="$t('MaterialCreateEdit.are-you-sure-you-want-to-delete-the-material-$', {materialName: material.name})"
		></bee-dialog>
	</v-form>
</template>

<script>
import rules from "@/validation";
import { mapGetters, mapState } from "vuex";
import  store  from "@/store/index.js";
import EventBus from '@/event-bus'
import actions from "@/permissions/actions-names.js"
import { multipleWarehouses, useInvoicesTypes, isMangeUnitAndRegionAndPatchAndLot } from '@/configs/global';
import { materialCategory, userType } from '@/helpers/enums'
export default {
   data: () => ({
	// configs
	useInvoicesTypes,
	materialCategory,
	multipleWarehouses,

	deleteDialog: false,
    readonly: true,
	actions,
    valid:false,
    material: {
		name: null,
		inner_no: null,
		type: null,
		category: null,
		purchase_price: null,
		sale_price: null,
		notes: null,
		parent_id: null,
		id: null,
		purchases_account_id: null,
		purchases_refund_account_id: null,
		sales_account_id: null,
		sales_refund_account_id: null,
		manufacturer: null,
		min_quantity: null,
		max_quantity: null,
		specifications: null,
		unit_size_id: null,
		barcode: null
    },
	...rules,
	loading : false,
	// selectedId : null,
	
	default_material:{
		name: null,
		inner_no: null,
		type: null,
		category: null,
		purchase_price: {
			amount: null,
			currency_id: null
		},
		sale_price: {
			amount: null,
			currency_id: null
		},
		notes: null,
		parent_id: null,
		id: null,
		purchases_account_id: null,
		sales_account_id: null,
		manufacturer: null,
		min_quantity: null,
		max_quantity: null,
		specifications: null,
		unit_size_id: null,
		barcode: null
	},
    editable: true,
	tableInputs: {},
	itemLinkedWithMaterials: [],
	materialSameBarcode: [],
	unbindDialog: false,
	itemId: null,
	userType,
	entriesUnitsLinked: [],
	tableInputsUnitLinked: {},
	itemsRegion: [],
	regions: [
		{
			name: 'A',
			class: 'A',
			column: '1',
			notes: 'لايوجد',
			id: 5
		},
		{
			name: 'B',
			class: 'S',
			column: '2',
			id: 1
		},
		{
			name: 'C',
			class: '12',
			column: 'w',
			id: 2
		}
	],
	tableInputRegion: {},
	rowEditIndexRegion: null,
	regionId: null,
	resetEditRegion: false,
	isEditRegion: false,
	tab: 0,
	resetEditUnit: false,
	isEditUnit: false,
	rowEditIndexUnit: null,
	unitId: null,
	isMangeUnitAndRegionAndPatchAndLot
  }),  
  mounted(){
	this.loading = false
	// this.selectedId = Number(this.$route.params.id)
	this.$route.name == "update-material"  ? this.readonly = true : this.readonly = false
    if(this.$route.name == "create-material")
		this.reSet() 
	if(this.$route.name == "add-material")
	{
		this.reSet() 
		this.initializeParent() 
	}
	if(
		(this.userTypePermission === userType.warehouseManger && this.$route.name !== 'create-material') 
		|| (this.isAdmin && this.$route.name !== 'create-material')
	) {
		this.getMaterialLinked()
	}
	// if(this.$route.name != "create-material") {
	if(!this.warehouses.length) {
		this.$store.dispatch('warehouses/fetchAll')
	}
	if(!this.materials.length) {
		this.$store.dispatch('materials/fetchAll')
	}
	// }
  },
  computed: {
	...mapState("configs", ["configs"]),
	...mapState("unitSizes", ["unit_sizes"]),
	...mapState("materials", ["warehouse_materials"]),
	...mapState({
		materials: state => state.materials.materials,
		warehouses: state => state.warehouses.warehouses,
		userTypePermission: state => state.permissions.user_type,
		isAdmin: state => state.auth.self.is_admin
	}),
	...mapGetters({
		getWarehousesById: 'warehouses/getById',
		getMaterialById: 'materials/getMaterialById'
	}),
	formTitle(){
		return this.this.$route.name == 'update-material'
			? this.$t('MaterialCreateEdit.edit-material')
			: this.$t('MaterialCreateEdit.create-material');
	},
	prefix(){
		if(this.material.parent_id)
			return this.warehouse_materials.find(c=>c.id == this.material.parent_id).no.toString()
		return null },
	file_is_locked(){
        return this.configs?.financial_file?.is_locked 
    },
	headers() {
		const headers = [
			{
				text: this.$t('inputs.warehouse'),
				name: 'warehouse_id',
				value: 'warehouse_id',
				setValueExpr: val => this.getWarehousesById(val)?.name
			},
			{
				text: this.$t('inputs.material'),
				name: 'id',
				value: 'id',
				setValueExpr: val => this.getMaterialById(val)?.name
			},
			{
				text: '',
				name: 'actions',
				value: 'actions',
				noInput: true
			}
		]
		return headers
	},
	headerSameBar() {
		const headers = [
			{
				text: this.$t('inputs.warehouse'),
				name: 'warehouse_id',
				value: 'warehouse_id',
				setValueExpr: val => this.getWarehousesById(val)?.name
			},
			{
				text: this.$t('inputs.material'),
				name: 'id',
				value: 'id',
				setValueExpr: val => this.getMaterialById(val)?.name
			},
			{
				text: this.$t('inputs.barcode'),
				name: 'barcode',
				value: 'barcode'
			},
			{
				text: '',
				name: 'actions',
				value: 'actions'
			}
		]
		return headers
	},
	headersLinkedUnit() {
		return [
			{
				text: 'اسم واحدة التغليف',
				name: 'packagingUnits',
				value: 'packagingUnits'
			},
			{
				text: 'العدد',
				name: 'count',
				value: 'count'
			},
			{
				text: 'الواحدة',
				name: 'unit',
				value: 'unit'
			},
			{
				text: '',
				name: 'actions',
				value: 'actions',
				noInput: true
			}
		]		
	},
	headersRegion() {
		return [
			{
				text: 'اسم المنطقة',
				name: 'name',
				value: 'name'
			},
			{
				text: 'الصف',
				name: 'class',
				value: 'class'
			},
			{
				text: 'العمود',
				name: 'column',
				value: 'column'
			},
			{
				text: 'الملاحظات',
				name: 'notes',
				value: 'notes'
			},
			{
				text: '',
				name: 'actions',
				value: 'actions',
				noInput: true
			}
		]
	}
},
methods:{
	initializeParent(){
		if (this.$route.name != 'update-material') // create account
		if(Number(this.$route.params.parentId))
		{
			this.material.parent_id = Number(this.$route.params.parentId)
			this.change()
		}
	},
	save(){
	this.loading = true;
	if(this.material.purchase_price?.amount)
		this.material.purchase_price.currency_id = this.configs.financial_file.default_currency_id 
	else
		this.material.purchase_price = null
	if(this.material.sale_price?.amount)
		this.material.sale_price.currency_id = this.configs.financial_file.default_currency_id 
	else
		this.material.sale_price = null
	if (this.$route.name == 'update-material')
	{	
		store.dispatch("materials/update", { warehouseId: this.$route.params.warehouseId, material: this.material })
		.then(() => 
			{ 
				this.$router.push({ name: "materials-tree"}).catch(()=>{})
				EventBus.$emit('reload-materials-tree')
				this.reSet()
			})
		.finally(() => { this.loading = false});
	}
    else {
        store.dispatch("materials/create", { warehouseId: this.$route.params.warehouseId, material:this.material })
			.then(() => 
				{ 
					this.$router.push({ name: "materials-tree"}).catch(()=>{})
					EventBus.$emit('reload-materials-tree')
					this.reSet()
				})
			.finally(() => {this.loading = false });
        }
      
    },
    cancel(){
		this.$router.push({ name: "materials-tree"}).catch(()=>{})
	},
	change(){
		this.$nextTick(()=> {
			// store.dispatch("warehouses/GenerateBarcode", { warehouseId: this.$route.params.warehouseId }).then(response =>{
			// 	this.material.barcode = response.data
			// })
			this.$refs.innerNo.setFocus();
			if(this.material.parent_id)
				store.dispatch("materials/GenerateNewInnerNo", { warehouseId: this.$route.params.warehouseId, materialId: this.material.parent_id }).then(response=>{
					this.material.inner_no = response
				})
		});
	},
	assignMoneyAmount(amount, currency_id){
      if(amount)
        return {amount, currency_id}
      return null
	},
	reSet(){
		this.deleteDialog = false
		this.material = {...this.default_material}
		this.$refs.form.resetValidation()
	},
	confirmDelete(){
		this.loading = true
		store.dispatch("materials/delete", { warehouseId: this.$route.params.warehouseId, materialId: this.$route.params.id })
			.then(() => 
				{ 
					this.$router.go(-1)
					EventBus.$emit('reload-materials-tree')
					this.reSet()
				})
			.finally(() => { 
				this.loading = false 
			});
	},

	getMaterialLinked() {
		this.$store.dispatch('warehouses/fetchMaterialLinkedWithMaterial', { materialId: this.$route.params.id }).then((data) => {
			// console.log(data)
			this.itemLinkedWithMaterials = data.data
		})
	},

	getMaterialBySameBarcode() {
		return this.$store.dispatch('warehouses/fetchMaterialSameBarcode', { 
			materialId: this.$route.params.id, 
			barcode: this.material.barcode
		}).then((data) => {
			this.materialSameBarcode = data.data
		})
	},

	link(id) {
		this.loading = true
		this.$store.dispatch('warehouses/linkedMaterial', { 
			materialId: this.$route.params.id, 
			linkedMaterialId: id ? id : this.tableInputs.id
		}).then(() => {
			this.getMaterialLinked()
			if(id) {
				this.getMaterialBySameBarcode()
			}
		}).finally(() => {
			this.loading = false
			this.$refs.table.resetInputs()
		})
	},

	deleteLinkItem () {
		this.loading = true
		this.$store.dispatch('warehouses/deleteLinkedItem', { 
			materialId: this.$route.params.id, 
			linkedMaterialId: this.itemId 
		}).then(() => {
			this.getMaterialBySameBarcode().finally(() => {
				this.loading = false
				this.itemId = null
				this.unbindDialog = false
			})
			this.getMaterialLinked()
		}).catch(() => {
			this.loading = true
		})
	},
	addUnitsLinked() {
		this.entriesUnitsLinked.push({
			...this.tableInputsUnitLinked
		})
		this.$refs.unitLinkedTable.resetInputs()
	},
	editUnitsLinked() {
		this.entriesUnitsLinked[this.rowEditIndexUnit].packagingUnits = this.tableInputsUnitLinked.packagingUnits
		this.entriesUnitsLinked[this.rowEditIndexUnit].unit = this.tableInputsUnitLinked.unit
		this.entriesUnitsLinked[this.rowEditIndexUnit].count = this.tableInputsUnitLinked.count

		this.resetEditUnit = true
		this.$refs.unitLinkedTable.resetEdit()
		this.isEditUnit = false
		this.resetEditRegion 
		this.$refs.unitLinkedTable.resetInputsFocus()
		this.$refs.unitLinkedTable.resetInputs()
	},

	setRowIndexUnit(rowData) {
		this.rowEditIndexUnit = rowData.index;
		this.unitId = rowData.id;
		this.isEditUnit = true
		this.$nextTick(() => {
			this.$refs.unitLinkedTable.resetInputsFocus()
		})
	},

	deleteUnit(index) {
		this.entriesUnitsLinked.splice(index, 1)
	},

	getClassAndColumn() {
		const region = this.regions.find(c => c.id === this.tableInputRegion.name)
		this.tableInputRegion.class = region.class
		this.tableInputRegion.column = region.column
	},
	addRegion() {
		this.itemsRegion.push({
			...this.tableInputRegion
		})
	},
	// editRegion() {
	// 	this.itemsRegion
	// },
		
	editRegion () {
		this.itemsRegion[this.rowEditIndexRegion].name = this.tableInputRegion.name
		this.itemsRegion[this.rowEditIndexRegion].class = this.tableInputRegion.class
		this.itemsRegion[this.rowEditIndexRegion].column = this.tableInputRegion.column
		this.itemsRegion[this.rowEditIndexRegion].notes = this.tableInputRegion.notes

		this.resetEditRegion = true
		this.$refs.regionTable.resetEdit()
		this.isEditRegion = false
		this.resetEditRegion 
		this.$refs.regionTable.resetInputsFocus()
		this.$refs.regionTable.resetInputs()
	},
	setRowIndexRegion(rowData) {
		this.rowEditIndexRegion = rowData.index;
		this.regionId = rowData.id;
		this.isEditRegion = true
		this.$nextTick(() => {
			this.$refs.regionTable.resetInputsFocus()
		})
	},

	deleteRegion({ index }) {
		this.itemsRegion.splice(index, 1)
	}
	
},
watch: {
	$route: function () {
		this.$route.name == "update-material"  ? this.readonly = true : this.readonly = false

		if(this.$route.name == "add-material")
		{
			this.reSet() 
			this.initializeParent() 
		}

		if(this.$route.name == "create-material")
			this.reSet() 
	}
},
async beforeRouteEnter(to, from, next) {
    next(vm => {
		if(to.params.id) {	
		store.dispatch("materials/fetch", { 
			warehouseId: Number(to.params.warehouseId), 
			materialId: Number(to.params.id) }).then((response) => { 
				vm.material = {...response } 
				if(vm.material.barcode) {
					store.dispatch('warehouses/fetchMaterialSameBarcode', { 
						materialId: vm.$route.params.id, 
						barcode: vm.material.barcode
					}).then((data) => {
						vm.materialSameBarcode = data.data
					})
				}
			})	
		}
	})
}
};
</script>